import { __assign, __read, __spreadArray, __values } from "tslib";
var FormError = /** @class */ (function () {
    function FormError(valid, error, message) {
        if (valid === void 0) { valid = false; }
        if (error === void 0) { error = false; }
        if (message === void 0) { message = ""; }
        this.valid = valid;
        this.error = error;
        this.message = message;
    }
    FormError.prototype.assert = function (state, errorMessage) {
        if (state) {
            this.setValid();
            return this;
        }
        this.setError(errorMessage);
        return null;
    };
    FormError.prototype.setError = function (message) {
        this.valid = false;
        this.error = true;
        this.message = message;
    };
    FormError.prototype.setValid = function () {
        this.valid = true;
        this.error = false;
        this.message = "";
    };
    return FormError;
}());
export { FormError };
var FormErrorMap = /** @class */ (function () {
    function FormErrorMap() {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        var _this = this;
        this.errorMap = {};
        keys.forEach(function (key) { return _this.errorMap[key] = new FormError(); });
    }
    FormErrorMap.prototype.append = function (key, formError) {
        if (formError === void 0) { formError = new FormError(); }
        this.errorMap[key] = formError;
        return this.errorMap[key];
    };
    FormErrorMap.prototype.appendMap = function (key, formErrorMap) {
        if (formErrorMap === void 0) { formErrorMap = new FormErrorMap(); }
        this.errorMap[key] = formErrorMap;
        return this.errorMap[key];
    };
    FormErrorMap.prototype.get = function (key) {
        return this.errorMap[key];
    };
    Object.defineProperty(FormErrorMap.prototype, "serialize", {
        get: function () {
            return Object.entries(this.errorMap).reduce(function (p, _a) {
                var _b, _c;
                var _d = __read(_a, 2), key = _d[0], value = _d[1];
                return value instanceof FormError && __assign(__assign({}, p), (_b = {}, _b[key] = value, _b))
                    || value instanceof FormErrorMap && __assign(__assign({}, p), (_c = {}, _c[key] = value.serialize, _c));
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormErrorMap.prototype, "isValid", {
        get: function () {
            return Object.values(this.errorMap).find(function (formError) {
                return formError instanceof FormError && !formError.valid
                    || formError instanceof FormErrorMap && !formError.isValid;
            }) == void 0;
        },
        enumerable: false,
        configurable: true
    });
    return FormErrorMap;
}());
export { FormErrorMap };
var FormFieldValidator = /** @class */ (function () {
    function FormFieldValidator(message) {
        this.message = message;
    }
    return FormFieldValidator;
}());
export { FormFieldValidator };
/**
 * Validation class
 *
 * validates all params and child params of an object that use at least one validate annotation
 */
var Validation = /** @class */ (function () {
    function Validation() {
    }
    Validation.validate = function (target, group) {
        var e_1, _a, e_2, _b;
        var _c;
        if (group === void 0) { group = 'default'; }
        var formErrorMap = new FormErrorMap();
        var name = target.constructor;
        var targetValidation = (Validation.validationMap[name] || {})[group] || {};
        var keys = __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(Object.keys(target)), false), __read(Object.keys(targetValidation)), false))), false);
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var childErrorMap = void 0;
                if (Validation.validationMap[(_c = target[key]) === null || _c === void 0 ? void 0 : _c.constructor]) {
                    childErrorMap = Validation.validate(target[key], group);
                    formErrorMap.appendMap(key, childErrorMap);
                }
                if (targetValidation[key] && (!childErrorMap || (childErrorMap === null || childErrorMap === void 0 ? void 0 : childErrorMap.isValid))) {
                    try {
                        for (var _d = (e_2 = void 0, __values(targetValidation[key])), _e = _d.next(); !_e.done; _e = _d.next()) {
                            var validator = _e.value;
                            var formError = validator.isValid(target[key]);
                            (childErrorMap || formErrorMap).append(key, formError);
                            if (formError.error)
                                break;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return formErrorMap;
    };
    Validation.addValidation = function (element, param, validator, groups, message) {
        var e_3, _a;
        if (groups === void 0) { groups = ['default']; }
        var name = element.constructor;
        if (!Validation.validationMap[name])
            Validation.validationMap[name] = { default: {} };
        try {
            for (var groups_1 = __values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                var group = groups_1_1.value;
                if (!Validation.validationMap[name][group])
                    Validation.validationMap[name][group] = {};
                if (!Validation.validationMap[name][group][param])
                    Validation.validationMap[name][group][param] = [];
                Validation.validationMap[name][group][param].push(new validator(message));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (groups_1_1 && !groups_1_1.done && (_a = groups_1.return)) _a.call(groups_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Validation.validationMap = {};
    return Validation;
}());
export { Validation };
/**
 * Validator annotation
 *
 * to be used for any class parameter.
 *
 * a class can be validated from the Validation static class
 *
 * @param validator takes the type of validator
 *
 * @param options takes a group list that defines in which group the parameter should be used
 */
export function Validate(validator, options) {
    return function (element, param) {
        Validation.addValidation(element, param, validator, options === null || options === void 0 ? void 0 : options.groups, options === null || options === void 0 ? void 0 : options.message);
    };
}
